module.exports = __webpack_public_path__ + "img/Color 019.44bb962b.jpg";